import React from "react";
import Heading from "../../../../../../components/common-components/zoom/components/heading/Heading";
import { HEADING } from "../../../../../../components/common-components/zoom/components/heading/constants/constants";
import { FieldRow, formatDate, renderObservationResult } from "./FHIRBundleViewer";

export const MedicationRequest = ({ resource, bundle }) => {
    const getResourceByReference = (referenceId) => {
      const entry = bundle?.entry?.find((entry) => entry.fullUrl === referenceId);
      return entry?.resource;
    };

    function removeLabel(line) {
        if (!line || typeof line !== 'string') return null;
        const index = line.indexOf(':');
        return index !== -1 ? line.slice(index + 1).trim() : line.trim();
    }
  
    const resultList =
      resource?.reasonReference?.map((item) => getResourceByReference(item.reference)) || [];
    return (
      <div className="mb-6 p-4 border border-gray-200 rounded">
          <Heading type={HEADING.H2} className="text-lg font-semibold mb-2">
              {resource.resourceType}
          </Heading>
          <FieldRow label="Status" value={resource.status} />
          <FieldRow label="Intent" value={resource.intent} />
          <FieldRow
              label="Medication"
              value={resource.medicationCodeableConcept?.text}
          />
          <FieldRow label="Authored On" value={formatDate(resource.authoredon)} />
          {resultList?.length > 0 && resultList[0]?.status &&
              <div className="mt-3">
                  <Heading type={HEADING.H4} className="font-medium mb-1">Reason Reference</Heading>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {resultList?.length > 0 &&
                      resultList.map((res, index) => (
                      <div key={index} className="mb-2 p-2 border border-gray-200 rounded">
                          {renderObservationResult(res)}
                      </div>
                      ))}
                  </div>
              </div>
          }
          {resource.dosageInstruction && resource.dosageInstruction?.length > 0 && (
              <div className="mt-3">
              {resource.dosageInstruction.map((dosage, index) => (  
                  <div key={index} className="grid grid-col-3  p-2 border-t border-gray-200">
                    <FieldRow label="Dosage Instruction" value={removeLabel(dosage?.text)}/>
                    <FieldRow label= "Additional Instruction" value={dosage?.additionalInstruction ? dosage?.additionalInstruction?.[0]?.text || dosage?.additionalInstruction?.[0]?.coding?.[0]?.display : null}/>
                    <FieldRow label="Route" value={removeLabel(dosage?.route?.text) || dosage?.route?.coding ? dosage?.route?.coding?.[0]?.display : null} />
                    <FieldRow label="Method" value={removeLabel(dosage?.method?.text) || dosage?.method?.coding ? dosage?.method?.coding?.[0]?.display : null} />
                    {/* <FieldRow label="Quantity" value={dosage?.timing?.repeat?.frequency || '-'} />
                    <FieldRow label="Duration" value={dosage?.timing?.repeat?.duration || '-'} /> */}
                    <FieldRow label="Duration Unit" value={dosage?.timing?.repeat?.durationUnit} />
                  </div>
              ))}
              {resource?.reasonCode?.length > 0 && (
                 <div className="grid grid-col-3 mb-2 p-2  border-gray-200">
                      {resource.reasonCode.map((codeItem, index) => (
                        <FieldRow  key={index}   label="Reason" value={removeLabel(codeItem?.text)} />
                     ))}
                </div>
               )}
              </div>
          )}
      </div>
    );
  };
